import React, { memo as Memo } from 'react';

//* Components
import CustomLink from 'components/common/CustomLink';
import Image from 'components/common/Image';

//* Styles
import LogoStyle from './style';

const Logo = Memo((props) => {
	return (
		<LogoStyle
			type={props.type}
			className={`${props.className || ''}`}>
			<CustomLink
				url={'/'}
				ariaLabel={props.ariaLabel || 'Website Logo'}
				content={
					<Image
						src={'/logo.svg'}
						alt='logo'
						priority
					/>
				}
			/>
		</LogoStyle>
	);
});

export default Logo;
